module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/_kosovo-b953ffb072b35f5fb5fcae731302eb0f.png";